import { mapDataSource, RawDataSource } from '~/Api/DataSource';
import { ApiClientError } from '~/ApiClient';
import Price from '~/utils/Price';

import { FinalCalculation } from './FinalCalculation';
import { mapError } from './mapError';

interface FinalCalculationProduct {
	id: string;
	dataSource: RawDataSource;
}

export interface RawFinalCalculation {
	currency: string | null;
	secondAndThirdLowestPriceAvg: string | null;
	threeLowestPricesAvg: string | null;
	deviation: number | null;
	emptyResultReason: ApiClientError[];
	fromProducts: FinalCalculationProduct[];
}

export function mapFinalCalculation(finalCalculation: RawFinalCalculation): FinalCalculation {
	const { secondAndThirdLowestPriceAvg, threeLowestPricesAvg, currency } = finalCalculation;

	return new FinalCalculation(
		currency,
		secondAndThirdLowestPriceAvg !== null && currency !== null
			? new Price(secondAndThirdLowestPriceAvg, currency)
			: null,
		threeLowestPricesAvg !== null && currency !== null ? new Price(threeLowestPricesAvg, currency) : null,
		finalCalculation.deviation,
		finalCalculation.emptyResultReason.map(mapError),
		finalCalculation.fromProducts.map((product) => ({
			id: product.id,
			dataSource: mapDataSource(product.dataSource),
		}))
	);
}
